const scriptLoaded = src => document.querySelector(`script[src="${src}"]`)

const loadScriptPromise = (src, name) =>
  new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      resolve(null)
      return
    }
    if (scriptLoaded(src)) {
      resolve(window[name])
      return
    }
    const el = document.createElement('script')
    el.async = true
    el.src = src
    el.onload = () => {
      el.onerror = el.onload = null
      resolve(window[name])
    }
    el.onerror = () => {
      el.onerror = el.onload = null
      reject(new Error(`Failed to load ${src}`))
    }
    document.head.appendChild(el)
  })

export default loadScriptPromise
